export const DELETE_OFFER_REQUEST = 'DELETE_OFFER_REQUEST';
export const DELETE_OFFER_SUCCESS = 'DELETE_OFFER_SUCCESS';
export const DELETE_OFFER_FAILURE = 'DELETE_OFFER_FAILURE';
